import React, { useEffect, useState } from "react";
import { config } from "../../utils/config";
import { getCookie } from "../../utils/cookieHandler";
import { useSelector, useDispatch } from "react-redux";
import { popQueue } from "../../redux/processQueueSlice";
import { classNames, findDataInFields } from "../../utils/helperFuctions";
import { displayName } from "react-quill";

const FileFetcher = ({
  name,
  label,
  url,
  defaultValue,
  buttonText,
  withID,
  id,
  saveChanges,
  download_url,
  extraButton,
  handleChange,
  hideButton,
  callPopUp,
  listView,
  hideComponent,
  fields,
  reservationCode,
  filename,
  params,
  hideIfField,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const checkIfIsHidden = () => {
    let isHidden = false;
    if (hideComponent != null) {
      hideComponent.forEach((component) => {
        const statement = findDataInFields(fields, component.if);
        if (component.equalsTo === statement) {
          isHidden = true;
        }
      });
    }
    return isHidden;
  };
  const isHidden = checkIfIsHidden();
  const processQueue = useSelector((state) => state.processQueue);
  const dispatch = useDispatch();
  const [reservId, setReservId] = useState(id);

  const initFilePreview = (value) => {
    if (value.type == null) return;
    if (value.type.startsWith("image/")) {
      return (
        <img
          src={`${config.apiUrl}/assets/${value.name}`}
          alt="File Preview"
          className="max-w-full max-h-32"
        />
      );
    } else if (value.type === "application/pdf") {
      return (
        <embed
          src={`${config.apiUrl}/assets/${value.name}`}
          type="application/pdf"
          width="100%"
          height="150"
        />
      );
    } else {
      console.error("Unsupported file type:", value.type);
    }

    return null;
  };

  const [filePreview, setFilePreview] = useState(
    defaultValue ? initFilePreview(defaultValue) : null
  );

  const handleFetchFile = async (e, flag) => {
    if (flag === true) return;
    e?.preventDefault();
    let imageUrl; // Declare imageUrl here
    let _reservID;
    try {
      setIsLoading(true);
      const savedChanges = await saveChanges(e, true);
      // wait 1 second do not delete , uploading seems to take time so contract was generating with no signature
      await new Promise((resolve) => setTimeout(resolve, 1000));

      if (savedChanges === null || savedChanges === undefined) {
        setIsLoading(false);
        throw new Error(
          "Complete adding required data before generating the contract"
        );
      }

      if (savedChanges?.id) {
        setReservId(savedChanges.id);
        _reservID = savedChanges.id;
      }
      const _response = await fetch(
        `${config.apiUrl}/api/${url}${
          withID && _reservID ? "/" + _reservID : ""
        }${params != null ? params : ""}`,
        {
          headers: {
            Authorization: `Bearer ${getCookie("_AT")}`,
          },
        }
      );
      const response = await _response;
      if (!(response.status >= 200 && response.status < 300)) {
        setIsLoading(false);
        throw new Error(
          "Complete adding required data before generating the contract"
        );
      }
      const blob = await _response.blob();

      if (blob.type.startsWith("image/")) {
        imageUrl = URL.createObjectURL(blob);
        setFilePreview(
          <img
            src={imageUrl}
            alt="File Preview"
            className="max-w-full max-h-32"
          />
        );
      } else if (blob.type === "application/pdf") {
        setFilePreview(
          <embed
            src={URL.createObjectURL(blob)}
            type="application/pdf"
            width="100%"
            height="150"
          />
        );
      }
      // else if (blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      //   setFilePreview(
      //     <iframe
      //       src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
      //       width="100%"
      //       height="150"
      //       frameBorder="0"
      //     />
      //   );
      // }
      else {
        console.error("Unsupported file type:", blob.type);
      }
      setIsLoading(false);

      // Clean up the URL.createObjectURL
      URL.revokeObjectURL(imageUrl);

      // You can also trigger automatic download here if needed
      //triggerAutomaticDownload(blob);
    } catch (error) {
      console.error("Error fetching file:", error);
    }
  };

  const triggerAutomaticDownload = (blob) => {
    // Trigger download
    const downloadAnchor = document.createElement("a");
    const downloadUrl = URL.createObjectURL(blob);
    downloadAnchor.href = downloadUrl;
    downloadAnchor.download = "downloaded_file"; // You can set a specific filename here
    document.body.appendChild(downloadAnchor);
    downloadAnchor.click();
    document.body.removeChild(downloadAnchor);

    // Clean up the URL.createObjectURL
    URL.revokeObjectURL(downloadUrl);
  };

  // const handleDownloadFile = async (e) => {
  //   e.preventDefault();
  //   try {
  //     if (download_url) {
  //       const response = await fetch(
  //         `${config.apiUrl}/api/${download_url}${
  //           withID && reservId ? "/" + reservId : ""
  //         }`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${getCookie("_AT")}`,
  //           },
  //         }
  //       );

  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }

  //       const blob = await response.blob();
  //       const downloadUrl = window.URL.createObjectURL(blob);

  //       // Create an anchor element and trigger a download
  //       const link = document.createElement("a");
  //       link.href = downloadUrl;

  //       // Set the desired filename
  //       const finalFilename = `${reservationCode} - ${filename}.pdf`;
  //       link.setAttribute("download", finalFilename);

  //       // Append the link to the body
  //       document.body.appendChild(link);

  //       // Programmatically click the link to trigger the download
  //       link.click();

  //       // Remove the link from the document
  //       document.body.removeChild(link);

  //       // Release the object URL
  //       window.URL.revokeObjectURL(downloadUrl);
  //     }
  //   } catch (error) {
  //     console.error("Error downloading file:", error);
  //   }
  // };

  const handleDownloadFile = async (e) => {
    e.preventDefault();
    try {
      if (download_url) {
        // Construct the URL
        const pdfUrl = `${config.apiUrl}/api/${download_url}${
          withID && reservId ? "/" + reservId : ""
        }`;

        // Fetch the PDF URL from the backend
        const response = await fetch(pdfUrl, {
          headers: {
            Authorization: `Bearer ${getCookie("_AT")}`,
          },
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        // Assume response contains the PDF URL
        const { url } = await response.json(); // Ensure the backend returns `{ url: 'pdf-url' }`

        // Open the PDF URL in a new tab
        // change target to _blank to open in a new tab
        const a = document.createElement("a");
        a.href = `${config.apiUrl}${url}`;
        a.target = "_blank";
        a.download = ""; // Let the browser decide filename
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        // window.location.href = `${config.apiUrl}${url}`;
      }
    } catch (error) {
      console.error("Error opening PDF:", error);
    }
  };

  const handleExtraButton = (e) => {
    if (e) {
      e.preventDefault();
    }

    if (extraButton?.param) {
      const _e = {
        target: {
          name: extraButton.param,
          value: extraButton.value,
        },
      };
      if (handleChange instanceof Function) handleChange(_e);

      if (extraButton.apiUrl && withID && id) {
        try {
          if (callPopUp instanceof Function) {
            callPopUp({
              title: "Saving data...",
              showPopUp: true,
              hideCancel: true,
              hideMainButton: true,
              showLoading: true,
            });
          }

          fetch(`${config.apiUrl}/api/${extraButton.apiUrl}/${reservId}`, {
            method: "PUT", // specify the HTTP method
            headers: {
              "Content-Type": "application/json", // set the Content-Type header if sending JSON data
              // add any other headers if necessary
              Authorization: `Bearer ${getCookie("_AT")}`,
            },
            body: JSON.stringify({ [extraButton.param]: extraButton.value }), // convert data to JSON string if sending JSON data
          })
            .then((response) => {
              // handle the response
              if (response.status >= 200 && response.status <= 299) {
                if (callPopUp instanceof Function) {
                  callPopUp({
                    isError: false,
                    title: "Data saved successfully",
                    showPopUp: true,
                    hideCancel: true,
                  });
                } else {
                  alert("Saved Successfully");
                }
              }
            })
            .catch((error) => {
              // handle errors
              console.log(error?.message);
            });
        } catch (error) {
          console.log(error?.message);
        }
      }
    }
  };

  useEffect(() => {
    if (processQueue?.queue) {
      if (processQueue.queue[name]) {
        dispatch(popQueue({ key: name }));
        handleFetchFile();
      }
    }
  }, [processQueue]);
  if (hideIfField != null) {
    const fieldValue = findDataInFields(fields, hideIfField.field);
    if (fieldValue === hideIfField.equalsTo) {
      return null;
    }
  }
  return (
    <>
      {isHidden === true ? (
        <div></div>
      ) : isLoading === true ? (
        <div className="pl-4 flex gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="animate-spin"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="24"
            height="24"
            strokeWidth="2"
          >
            <path d="M12 3a9 9 0 1 0 9 9"></path>{" "}
          </svg>
          <div>Generating {filename}</div>
        </div>
      ) : (
        <>
          {listView != null ? (
            <>
              {filePreview && (
                <div className="mx-6  border-t-[1px] border-b-[1px] py-4">
                  <button
                    type="button"
                    className="text-[#7E22CE]"
                    style={{
                      textDecorationLine: "underline",
                    }}
                    onClick={handleDownloadFile}
                  >
                    {listView.displayName}
                  </button>
                </div>
              )}
            </>
          ) : (
            <div>
              {label && (
                <label
                  htmlFor={name}
                  className="block text-sm font-medium leading-6 text-gray-900 text-left"
                >
                  {label}
                </label>
              )}
              {filePreview && <div className="mb-4">{filePreview}</div>}
              {!hideButton && (
                <button
                  className="px-4 py-2 bg-purple-700 text-white rounded"
                  onClick={handleFetchFile}
                >
                  {buttonText || "Fetch File"}
                </button>
              )}

              {filePreview && (
                <button
                  className={classNames(
                    hideButton ? "" : "ml-4",
                    "px-4 py-2 bg-[#7E22CE] text-white rounded mt-2"
                  )}
                  onClick={handleDownloadFile}
                >
                  Download
                </button>
              )}
              {extraButton && filePreview && (
                <button
                  className="ml-4 px-4 py-2 bg-[#7E22CE] text-white rounded mt-2"
                  onClick={handleExtraButton}
                >
                  {extraButton.text}
                </button>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default FileFetcher;
